import script from "./users.vue?vue&type=script&setup=true&lang=js"
export * from "./users.vue?vue&type=script&setup=true&lang=js"

import "./users.vue?vue&type=style&index=0&id=a15a7cc4&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a15a7cc4"]])

export default __exports__